import { render, staticRenderFns } from "./AppReminderNotificationContainer.vue?vue&type=template&id=5510cb0e&scoped=true&"
import script from "./AppReminderNotificationContainer.vue?vue&type=script&lang=js&"
export * from "./AppReminderNotificationContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppReminderNotificationContainer.vue?vue&type=style&index=0&id=5510cb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510cb0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCard,VCardText,VCardTitle,VCol,VContainer,VList,VListItem,VMenu,VRow})
